export const DEFAULT_BACKUP_ZIP_PASSWORD = "NoarBackup*2025";
